module.exports = __webpack_public_path__ + "static/media/Background2_AcercaDe_1920.5a9a1751.png";